<template>
    <div class="contacts">
        <Title :title="'Contactos'"></Title>
        <div class="row center-xs contacts-line">
            <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6 mobile-padded__evenly">
                <div class="row">
                    <div class="col-xs-12 col-sm-8">
                        <ContactForm/>
                    </div>
                    <div class="col-xs-12 col-sm-4 contact-find-us">
                        <h2>Encontre-nos</h2>
                        <h6>Morada</h6>
                        <p class="find-us-field">Rua Alves Torgo 16B Lisboa</p>
                        <h6>Email</h6>
                        <p class="find-us-field">info@cota8086.pt</p>
                        <h6>Telefone</h6>
                        <p class="find-us-field">(+351) 927 775 548</p>
                    </div>

                </div>
            </div>
        </div>
        <div class="row center-xs contacts-line">
            <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6 image mobile-padded__evenly">
                <iframe
                        id="map"
                        class="map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3112.3494691111964!2d-9.137975784654502!3d38.732742079596434!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd19339838da7a65%3A0xb9141838d5686536!2sR.%20Alves%20Torgo%2016B%2C%201000-033%20Lisboa!5e0!3m2!1spt-PT!2spt!4v1585153986569!5m2!1spt-PT!2spt" frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import Title from "../generic/Title";
    import ContactForm from "../generic/ContactForm";

    export default {
        name: "Contacts",
        components: {ContactForm, Title}
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";

    .contacts {
        margin-top: 3em;
        margin-bottom: 10em;
    }

    .separator {
        background-color: $primary;
        height: 0.4em;
        width: 2.4em;
        display: inline-block;
        margin-bottom: 0.8em;
    }

    .contacts-title {
        margin-top: 2em;
        margin-bottom: 2em;
    }

    .contacts-line {
        margin-top: 3em;
        margin-bottom: 4em;

        .contact-find-us {
            text-align: left;
            padding-left: 2em;
            p {
                color: #4F4F4F;
                text-transform: uppercase;
                font-weight: 500;
                letter-spacing: 0.2em;
            }
        }

        @media only screen and (max-width: 767px) {
            .contact-find-us {
                padding-left: 0;
                margin-top: 2em;
            }
        }
    }

    .image {
        width: 100%;
        .map {
            height: 20em;
            width: 100%;
        }
    }

    h6 {
        font-size: x-small;
        font-weight: 900;
    }

</style>
